import Vue from 'vue'
import SvgIcon from '../../../common/components/svg-icon/index.vue' // svg组件

// register globally
Vue.component('svg-icon', SvgIcon)

const requireAll = (requireContext) => requireContext.keys().map(requireContext)

const reqCommonSvg = require.context('@com/icons/svg/common', false, /\.svg$/)
requireAll(reqCommonSvg)

const reqPtCommonSvg = require.context('@com/icons/svg/pt', false, /\.svg$/)
requireAll(reqPtCommonSvg)

const reqVeCommonSvg = require.context('@com/icons/svg/ve', false, /\.svg$/)
requireAll(reqVeCommonSvg)

const req = require.context('./svg', false, /\.svg$/)
requireAll(req)

const reqFontSvg = require.context('@com/icons/svg/font', false, /\.svg$/)
requireAll(reqFontSvg)

const requireCategorySvg = require.context('./svg/category', false, /\.svg$/)
requireAll(requireCategorySvg)

const requirePtSvg = require.context('@com/icons/svg/pt-ic', false, /\.svg$/)
requireAll(requirePtSvg)
